/**
 * Requirements Service
 * API operations for task requirements (checklist items)
 */
import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';
import type {
  AddRequirementRequest,
  UpdateRequirementRequest,
} from '@/types/api/requests';
import type { RequirementResponseDto } from '@/types/api/responses';

export const requirementsService = {
  /**
   * Add a new requirement to a task
   */
  add: (taskId: string, data: AddRequirementRequest) =>
    apiClient.post<RequirementResponseDto>(
      API_ENDPOINTS.REQUIREMENTS.BASE(taskId),
      data
    ),

  /**
   * Update an existing requirement
   */
  update: (taskId: string, requirementId: string, data: UpdateRequirementRequest) =>
    apiClient.put<RequirementResponseDto>(
      API_ENDPOINTS.REQUIREMENTS.BY_ID(taskId, requirementId),
      data
    ),

  /**
   * Delete a requirement from a task
   */
  delete: (taskId: string, requirementId: string) =>
    apiClient.delete<void>(
      API_ENDPOINTS.REQUIREMENTS.BY_ID(taskId, requirementId)
    ),
};
